import { useMap } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';
import { boundsToBBox } from '../utils/geojson';
import { degreesPerPixel } from '@/utils/map';

/**
 * @param {object} options
 * @param {number} [options.padding] Padding in pixels
 */
export function useMapViewport({ padding = 0 } = {}) {
  const map = useMap();
  const [zoom, setZoom] = useState(map?.getZoom() ?? 0);
  const [bbox, setBbox] = useState(boundsToBBox(map?.getBounds(), degreesPerPixel(zoom) * padding));

  // observe the map to get current bounds
  useEffect(() => {
    if (!map) return;

    const listener = map.addListener('idle', () => {
      const bounds = map.getBounds();
      const zoom = map.getZoom();

      if (!bounds || !zoom) return;

      const paddingDegrees = degreesPerPixel(zoom) * padding;
      setBbox(boundsToBBox(bounds, paddingDegrees));
      setZoom(zoom);
    });

    return () => listener.remove();
  }, [map, padding]);

  return { bbox, zoom };
}
